// @ts-strict-ignore
import dynamic from 'next/dynamic';
// eslint-disable-next-line no-restricted-imports
import React from 'react';

const ErrorDisplay = dynamic(() => import('./ErrorDisplay'));

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }

  async componentDidCatch(error: Error, info: React.ErrorInfo) {
    const { recordError } = await import('../../analytics/uiMetrics');
    recordError(error, info.componentStack);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorDisplay />;
    }

    return children;
  }
}

export default ErrorBoundary;
